import React from 'react';

/* Styles */
import './PublicEvents.css';

/**
 * Modules
 */
import { Input, List, Card } from 'antd';
import { Link } from 'react-router-dom';

const PublicEventsView = (props) => {
	return (
		<div className='publicEventsCentralDiv'>
			<a id="events"><div style={{ height: '80px' }} /></a>

			<div className='publicHomeAdSense'></div>

			<div className='publicEventsBody'>
				<h4 style={{ color: 'white' }}>Eventos</h4>

				<div className='publicEventsSearchContainer'>
					<div className='publicEventsSearch'>
						<Input
							placeholder='Buscar eventos'
							onChange={e => props.searchEvent(e.target.value)}
							className='sharedInput'
							style={{ color: 'white' }}
						/>
					</div>
				</div>
				<List
					grid={{
						gutter: 16, //column: 4 
						xs: 1,
						sm: 2,
						md: 2,
						lg: 3,
						xl: 4,
						xxl: 6,
					}}
					dataSource={props.arrayOfEvents}
					loading={props.loading}
					pagination={{ pageSize: 4 }}
					locale={{ emptyText: <span style={{ color: 'white' }}>Nenhum evento encontrado</span> }}
					renderItem={event => (
						<List.Item>
							<Link to={`/event?id=${event.__key}`}>
								<Card title={event.nome}>
									<div className='publicEventsCardImg' style={{ backgroundImage: `url(${event.img})` }} />
								</Card>
							</Link>
						</List.Item>
					)}
				/>
			</div>
			<div style={{ clear: 'both', paddingBottom: '50px' }}></div>
		</div>
	)
}

export default PublicEventsView